import 'primeicons/primeicons.css' // Import PrimeIcons CSS globally
import {definePreset} from '@primeuix/themes'
import Aura from '@primeuix/themes/aura'
import {ToastService} from 'primevue'
import PrimeVue from 'primevue/config'
import type {App} from 'vue'

import setupI18n from './i18n'
import router from './router'
import store from './stores/setup'

export default (app: App) => {
  console.info('Setting up app dependencies...')

  setupI18n(app)
  app.use(store)
  app.use(router)
  app.use(ToastService)

  const customPreset = definePreset(Aura, {
    semantic: {
      primary: {
        50: '#e6e9eb',
        100: '#cfd5da',
        200: '#a9b3bb',
        300: '#7b8c99',
        400: '#556776',
        500: '#000A16', // base
        600: '#006A6F',
        700: '#162229',
        800: '#000A16',
        900: '#000A16',
        950: '#000A16',
      },
    },
  })

  app.use(PrimeVue, {
    theme: {
      preset: customPreset,
      options: {
        prefix: 'p',
        darkModeSelector: 'light',
        cssLayer: false,
      },
    },
  })
}
